export class UserModule {
  UserId: number;
  ModuleId: number;

  constructor(userId: number, moduleId: number) {
    this.UserId = userId;
    this.ModuleId = moduleId;
  }
}